export const CRS: string = "https://www.eecs.yorku.ca/~roumani/course/4141";
export const MEE: string = "https://www.eecs.yorku.ca/~roumani";
export const BOK: string = "https://www.eecs.yorku.ca/~roumani/q/book/";
